import React, { useState } from 'react';
import '../../index.css';

const TargetDashboard = () => {
    // Streamlit service URL
    // If Streamlit is running locally, use localhost
    // In production, configure the correct URL
    const streamlitUrl = process.env.REACT_APP_STREAMLIT_URL || 'https://dashboard.sunwinnyc.it.com';
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    
    const handleLoad = () => {
        setIsLoading(false);
        setHasError(false);
    };
    
    const handleError = () => {
        setIsLoading(false);
        setHasError(true);
    };
    
    return (
        <div className="min-h-screen bg-gray-900">
            {isLoading && (
                <div className="flex items-center justify-center h-screen">
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                        <p className="text-white text-lg">Loading Target Dashboard...</p>
                        <p className="text-gray-400 text-sm mt-2">If it takes too long to load, please ensure the Streamlit service is running</p>
                    </div>
                </div>
            )}
            
            {hasError && (
                <div className="flex items-center justify-center h-screen">
                    <div className="text-center bg-gray-800 p-8 rounded-lg border border-red-500 max-w-md">
                        <div className="text-red-500 text-4xl mb-4">⚠️</div>
                        <h2 className="text-white text-xl font-bold mb-2">Unable to connect to Streamlit service</h2>
                        <p className="text-gray-400 mb-4">
                            Please ensure the Streamlit service is running at: <code className="bg-gray-700 px-2 py-1 rounded">{streamlitUrl}</code>
                        </p>
                        <div className="text-left text-gray-300 text-sm space-y-2">
                            <p>Solutions:</p>
                            <ol className="list-decimal list-inside space-y-1 ml-4">
                                <li>Run in terminal: <code className="bg-gray-700 px-1 rounded">./start-streamlit.sh</code></li>
                                <li>Or start manually: <code className="bg-gray-700 px-1 rounded">streamlit run target_dashboard6.py --server.port 8501</code></li>
                                <li>Check if port 8501 is already in use</li>
                            </ol>
                        </div>
                        <button
                            onClick={() => {
                                setHasError(false);
                                setIsLoading(true);
                                window.location.reload();
                            }}
                            className="mt-4 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded transition"
                        >
                            Retry
                        </button>
                    </div>
                </div>
            )}
            
            <div className="w-full h-screen" style={{ display: hasError ? 'none' : 'block' }}>
                <iframe
                    src={streamlitUrl}
                    title="Target Retail Analytics Dashboard"
                    className="w-full h-full border-0"
                    style={{ minHeight: '100vh', display: isLoading ? 'none' : 'block' }}
                    allow="fullscreen"
                    onLoad={handleLoad}
                    onError={handleError}
                />
            </div>
        </div>
    );
};

export default TargetDashboard;

